import {createContext,} from 'react';

type UserAttributesContextType = {
    sub: string,
    zoneInfo: string,
    website: string,
    address: string,
    emailVerified: boolean,
    profile: string,
    accountAdmin: boolean,
    locale: string,
    givenName: string,
    picture: string,
    name: string
    nickname: string
    accountId: string
    familyName: string,
    email: string,
    phoneNumber: string,
    middleName: string,
    birthdate: string,
    gender: string
}


export const UserAttributesContext = createContext<UserAttributesContextType>({} as UserAttributesContextType);



